import vehicleMaintenance from "../components/views/vehiclemaintenance/vehicleMaintenance.vue";
import vehicleMaintenanceCreate from "../components/views/vehiclemaintenance/vehicleMaintenanceCreate.vue";

const routes = [
  {
    path: "vehicleMaintenance",
    component: vehicleMaintenance,
    name: "vehicleMaintenance",
    meta: {
      description: "List of Vehicle Maintenance",
      title: "Vehicle Maintenance",
      requiresAuth: true,
    },
  },
  {
    path: "vehiclemaintenance/vehicleMaintenanceCreate/:_id",
    component: vehicleMaintenanceCreate,
    name: "vehicleMaintenanceCreate",
    meta: {
      description: "",
      title: "Add / Update Vehicle Maintenance",
      requiresAuth: true,
    },
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/vehicleMaintenance.route.js